/**
 * @name Snackbar
 * @description Componente común de notificaciones snackbar (success, error, info, warnign)
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icons } from '@styles';

// Material-UI
import MuiSnackbarContent from '@material-ui/core/SnackbarContent';
import Slide from '@material-ui/core/Slide';

class Snackbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: false
    };
  }

  componentDidMount() {
    this.setState({ slide: true });
    setTimeout(() => {
      this.removeSnack();
    }, 4000);
  }

  removeSnack = () => {
    this.setState({ slide: false });
    setTimeout(() => {
      this.props.removeSnack(this.props.id);
    }, 300);
  };

  typeIcon = (type) => {
    switch (type) {
      case 'success':
        return <Icons.Check />;
      case 'info':
        return <Icons.Info />;
      case 'error':
        return <Icons.Error />;
      case 'warn':
        return <Icons.Warn />;
    }
  };

  render() {
    return (
      <div key={this.props.id}>
        <Slide in={this.state.slide} direction="left" mountOnEnter unmountOnExit>
          <Styled.SnackbarContent
            color={this.props.variant}
            message={
              <>
                <Styled.BoxIcon>
                  {this.typeIcon(this.props.variant)}
                </Styled.BoxIcon>
                {this.props.message}
              </>
            }
            action={
              <Styled.BoxClose onClick={() => this.removeSnack()}>
                <Icons.Close />
              </Styled.BoxClose>
            }
          />
        </Slide>
      </div>
    );
  }
}

Snackbar.propTypes = {
  // Id del componente snackbar.
  id: PropTypes.string.isRequired,
  // Mensaje del componente snackbar.
  message: PropTypes.string.isRequired,
  // Tipo de componente snackbar.
  variant: PropTypes.string.isRequired,
  // Función para eliminar snackbar.
  removeSnack: PropTypes.func
};

// *************************************
// STYLED COMPONENTS
// *************************************

const snackbarColor = {
  success: (props) => props.theme.colors.green,
  error: (props) => props.theme.colors.red,
  info: (props) => props.theme.colors.blueMedium,
  warning: (props) => props.theme.colors.orange,
};

const Styled = {};

Styled.BoxIcon = styled.div`
  display: flex;
  margin-right: 12px;
  color: ${(props) => props.theme.colors.white};

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

Styled.BoxClose = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px;
  width: 18px;
  color: ${(props) => props.theme.colors.white};

  .MuiSvgIcon-root {
    font-size: 14px;
    &:hover {
      font-size: 20px;
    }
  }
`;

// SnackbarContent
Styled.SnackbarContent = styled(MuiSnackbarContent)`
  &.MuiSnackbarContent-root {
    min-height: 70px;
    padding: 12px;
    margin: 12px 0px;
    font-family: 'Bryant Pro Regular';
    font-variant: tabular-nums;
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: 1.3;
    letter-spacing: 0.0175em;
    border-radius: 6px;
    background-color: ${(props) => snackbarColor[props.color]};
  }
            
  @media screen and (min-width: 600px) {
    &.MuiSnackbarContent-root {
      width: 360px;
    }
  }

  .MuiSnackbarContent-message {
    display: flex;
    align-items: center;
    padding: 0px;
    width: 85%;
  }
  
  .MuiSnackbarContent-action {
    display: flex;
    align-items: center;
    padding: 0px;
    margin-right: -12px;
  } 
`;

export default Snackbar;